module.exports = __webpack_public_path__ + "static/media/bank-icon-black.4064ea41.svg";